import _ from "lodash";
import { MyDocumentsType } from "src/types/main";
import { getCodeIndexQueryParts } from "src/utils/searchFilter.utils";

const cleanHighlightMarkers = (text: string): string => {
  return text.replace(/\[highlight\](.*?)\[\/highlight\]/g, "$1");
};

const escapeRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const highlightQueryInText = (text: string, query: string): string => {
  const cleanedText = cleanHighlightMarkers(text);

  const parts = getCodeIndexQueryParts(query).filter(Boolean);
  if (parts.length === 0) {
    return cleanedText;
  }

  const pattern = parts.map(escapeRegex).join("|");
  const regex = new RegExp(`(${pattern})`, "gi");

  return cleanedText.replace(regex, "[highlight]$1[/highlight]");
};

export const searchAndHighlight = (
  items: MyDocumentsType[],
  query: string,
  searchPaths: string[]
): MyDocumentsType[] => {
  const parts = getCodeIndexQueryParts(query).filter(Boolean);

  return items.reduce((acc: MyDocumentsType[], item) => {
    let newItem = _.cloneDeepWith(item, (value) => {
      if (typeof value === "string") {
        return cleanHighlightMarkers(value);
      }
    });

    if (parts.length === 0) {
      acc.push(newItem);
      return acc;
    }

    let isMatchFound = false;
    const lowerParts = parts.map((p) => p.toLowerCase());

    searchPaths.forEach((path) => {
      const value = _.get(newItem, path);
      if (typeof value !== "string") return;
      const valueLower = value.toLowerCase();
      const hasAnyPart = lowerParts.some((p) => valueLower.includes(p));
      if (hasAnyPart) {
        const highlighted = highlightQueryInText(value, query);
        _.set(newItem, path, highlighted);
        isMatchFound = true;
      }
    });

    if (isMatchFound) acc.push(newItem);

    return acc;
  }, []);
};

export const renderHighlightedText = (text: string): JSX.Element => {
  const parts = text.split(/\[highlight\](.*?)\[\/highlight\]/g);

  return (
    <span>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <mark key={index} className="bg-[#fee391]">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
};
